
$(function(){
  
  $('.PairsWellButton').click(function(e) {
    e.preventDefault();

    var variant_id = $('.PairsWellButton').attr('variant_id');
    var variant_img = $('.PairsWellButton').attr('variant_image');
    var product_title = $('.PairsWellButton').attr('product_title');
    var variant_title = $('.PairsWellButton').attr('variant_title');
    
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      "id": parseInt($(this).attr('variant_id')),
      "quantity": 1
    },
    dataType: 'json',
    success: function() { 
      
      $('#cartModalImg').attr('src', variant_img);
      $('#cartModalTitle').html(product_title);
      $('#cartModalVariant').html(variant_title);
            
      jQuery.getJSON('/cart.js', function(cart) { 
        var cart_total = '$' + (cart.total_price / 100).toFixed(2)
        var total_left_for_free_shipping = ((5000 - cart.total_price) / 100).toFixed(2);
        var currency = cart.currency;

        $('.bag-total').html(cart_total);
        
        if (cart.total_price > 5000) { //change here for free shipping amount
          $('.cart-modal-free-shipping').html('Congratulations! You got free shipping and a free full size gift')
        } else {
          $('.cart-modal-free-shipping').html('You are $' + total_left_for_free_shipping + ' away from a free full size gift and free shipping.');
        }
        
      });

      $('.cart-modal').css('visibility','visible');
      $('.cart-modal').css('opacity','1');
      
      $(".PairsWellATC-Add").fadeOut(function() {
        $('.PairsWellATC-Added').fadeIn(400);
      });
	}
    });
  })
  
  $('.faq-zone-accordion-checkbox').click(function() {
    var current = $(this).attr('id');
    if ($(this).is(':checked')) {
      $('.faq-zone-accordion-checkbox').each(function() {
        if ($(this).attr('id') == current) { $(this).prop('checked', true); } 
        else { $(this).prop('checked', false); }
      })
    } else { $(this).prop('checked', false); }
  });

  $('.cart-modal .close').click(function() {
    $('.cart-modal').css('visibility','hidden');
    $('.cart-modal').css('opacity','0');
  })

  $('.cart-modal').mouseup(function(e) {
    var cart_modal_inner = $('.cart-modal-inner');

    if (!cart_modal_inner.is(e.target) && cart_modal_inner.has(e.target).length === 0) {
      $('.cart-modal').css('visibility','hidden');
      $('.cart-modal').css('opacity','0');      
    }
    
  });
  
});